module.exports = __webpack_public_path__ + "img/text-welcome-icantech.4eda5cfe.png";